// Libraries
var React = require('react');

// Components
var InlineShareModule = require('InlineShare/InlineShareModule');

// Assets
var PlaceholderImg = require('images/blankImgPlaceholder.png');

// Styles
require('./SingleImageModule.scss');

class SingleImageModule extends React.Component {
	// componentDidMount() {
	// 	const picturefill = require('picturefill');	
	// 	picturefill();
	// }

	handleImageSize = () => {
		// If img aspect ratio is more than 16:10 (e.g. 4:3 or portrait)
		if (this.img.naturalHeight / this.img.naturalWidth <= .625) {
			this.container.className += ' SingleImage__container--landscape';
		}
	};

	render() {
		const data = this.props.data;
		return (
			<div className="SingleImage">
				{data.image &&
					<div className={"SingleImage__container"} ref={(container) => { this.container = container; }}>
						<img src={PlaceholderImg} data-src={data.image.smallUrl + '*,*' + data.image.mediumUrl + '*,*' + data.image.largeUrl + '*,*' + data.image.extraLargeUrl} ref={(img) => { this.img = img; }} alt={data.imageAltText || data.image.altText} className="SingleImage__img" onLoad={this.handleImageSize}/>
					</div>
				}
				{data.caption &&
					<div className="SingleImage__caption">{data.caption}</div>
				}
				{data.sharing &&
					<div className="SingleImage__share">
						<InlineShareModule data={data.sharing} />
					</div>
				}
			</div>
		);
	}
}

module.exports = SingleImageModule;



// WEBPACK FOOTER //
// ./src/components/SingleImage/SingleImageModule.js